// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 19351 ? "a5ce6a92" : chunkId) + "." + {"544":"c2b5d6ebb2495818","5767":"4fd5369dee22a164","19351":"c1f7de0082641d15","53348":"d8fff340f695c7fb","57238":"fb97c86eefde2caa"}[chunkId] + ".js";
};